<template>
  <vn-bar
    :model="barChart.data"
    textField="label"
    valueField="value"
    :staggerLabels="barChart.staggerLabels"
    x-format=",.1f"
    y-format=",.2f"
  >
  </vn-bar>
</template>

<script>
export default {
  data() {
    var barChartData = [
      {
        key: "Cumulative Return",
        values: [
          { label: "Johor", value: 30.2013, color: "#E57373" },
          { label: "Kedah", value: 15.5039, color: "#F06292" },
          { label: "Kelantan", value: 13.2948, color: "#BA68C8" },
          { label: "Negeri Sembilan", value: 26.6055, color: "#9575CD" },
          { label: "Pahang", value: 28.3186, color: "#7986CB" },
          { label: "Perak", value: 34.6154, color: "#64B5F6" },
          { label: "Pulau Pinang", value: 17.9487, color: "#4DB6AC" },
          { label: "Sarawak", value: 23.2323, color: "#66BB6A" },
          { label: "Selangor", value: 16.8421, color: "#FFB74D" },
          { label: "Terengganu", value: 15.0442, color: "#66BB6A" },
        ],
      },
    ];
    return {
      barChart: {
        data: barChartData,
        staggerLabels: true,
      },

      
    };
  },
};
</script>
